module.exports = __webpack_public_path__ + "static/media/trailing-icon.550906eb.svg";